import { ADD_ENVIRONMENT, ADD_USER_PROFILE, REMOVE_USER_PROFILE } from "./types";

const USER_PROFILE_DEFAULT_STATE = {
  user: {},
  environment: localStorage.getItem("currentEnv") ? localStorage.getItem("currentEnv") : "production",
  // environment: "staging",
  availableEnvironments: ["sandbox", "staging", "production"],
  //   token: "",
};

const userProfileReducer = (state, action) => {
  switch (action.type) {
    case ADD_USER_PROFILE:
      return {
        ...state,
        user: action.payload,
        // token: action.payload.token,
      };
    case REMOVE_USER_PROFILE:
      return {
        ...state,
        user: {},
      };
    case ADD_ENVIRONMENT:
      return {
        ...state,
        environment: action.payload,
      };
    default:
      return state;
  }
};

export { USER_PROFILE_DEFAULT_STATE, userProfileReducer };
